import BorrowRequest from 'bzx-common/src/domain/borrow/BorrowRequest'
import RepayLoanRequest from 'bzx-common/src/domain/borrow/RepayLoanRequest'
import ManageCollateralRequest from 'bzx-common/src/domain/ManageCollateralRequest'
import { observer } from 'mobx-react'
import React from 'react'
import ManageCollateralForm from 'shared-components/ManageCollateralForm/ManageCollateralForm'
import WhyNoSir from 'shared-components/WhyNoSir/WhyNoSir'
import { Modal } from 'ui-framework'
import BorrowMoreForm from '../BorrowMoreForm'
import BorrowVM from '../BorrowVM'
import RepayLoanForm from '../RepayLoanForm'
import Loan from './Loan'

export type Request = ManageCollateralRequest | BorrowRequest | RepayLoanRequest | undefined

export function UserLoans({ vm }: { vm: BorrowVM }) {
  const { uiStore, web3Connection } = vm.rootStore
  const { smScreen } = uiStore.media
  const { loan, loans, request, filteredLoans, onClose, onLoanConfirmed } = vm.borrowStore

  if (!web3Connection.isConnected || (vm.borrowStore.loansChecked && loans.length === 0)) {
    return <WhyNoSir text="Why no borrow, ser?" buttonText="Borrow Now" link="/borrow/asset" />
  }

  return (
    <>
      {loan && (
        <Modal isOpen={vm.borrowStore.isOpen} onRequestClose={onClose}>
          {request instanceof ManageCollateralRequest && (
            <ManageCollateralForm
              closeModal={vm.borrowStore.onClose}
              loan={loan}
              request={request}
              rootStore={vm.rootStore}
              isBorrow
            />
          )}
          {request instanceof BorrowRequest && (
            <BorrowMoreForm
              loan={loan}
              rootStore={vm.rootStore}
              onSubmit={onLoanConfirmed}
              onCancel={onClose}
            />
          )}
          {request instanceof RepayLoanRequest && (
            <RepayLoanForm
              loan={loan}
              rootStore={vm.rootStore}
              isMobileMedia={smScreen}
              onSubmit={onLoanConfirmed}
              onCancel={onClose}
            />
          )}
        </Modal>
      )}

      <div className="user-loans margin-top-2 margin-bottom-4">
        {filteredLoans.map((loan) => (
          <Loan key={loan.loanId} loan={loan} />
        ))}
        {/** Trick to align items with tabs when there is only one */}
        {filteredLoans.length === 1 && <div />}

        {filteredLoans.length === 0 && vm.rootStore.borrowStore.searchQuery && (
          <p className="txt-center margin-top-2">
            <i>The filter returned 0 result.</i>
          </p>
        )}
      </div>
    </>
  )
}

export default observer(UserLoans)
